import { SensorInjection } from '../models/sensorInjection'

export interface SensorInjectionStateType {
  sensorInjections: SensorInjection[]
  sensorInjection: SensorInjection | null
}

const SensorInjectionState: () => SensorInjectionStateType = () => ({
  sensorInjections: [],
  sensorInjection: null,
})

export default SensorInjectionState
